module.exports = __webpack_public_path__ + "static/media/nate.fd515d09.png";